"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enUS = _interopRequireDefault(require("./en-US"));
var _deDE = _interopRequireDefault(require("./de-DE"));
var _nl_NL = _interopRequireDefault(require("./nl_NL"));
var _esUS = _interopRequireDefault(require("./es-US"));
var _jaJP = _interopRequireDefault(require("./ja-JP"));
var _enGB = _interopRequireDefault(require("./en-GB"));
var _frFR = _interopRequireDefault(require("./fr-FR"));
var _frCA = _interopRequireDefault(require("./fr-CA"));
var _enCA = _interopRequireDefault(require("./en-CA"));
var _ptBR = _interopRequireDefault(require("./pt-BR"));
var _esMX = _interopRequireDefault(require("./es-MX"));
var _enAU = _interopRequireDefault(require("./en-AU"));
var _enIE = _interopRequireDefault(require("./en-IE"));
var _itIT = _interopRequireDefault(require("./it-IT"));
var _svSE = _interopRequireDefault(require("./sv-SE"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Considering the number of messages are too less,
 * import them all together.
 * If number of messages scales, we need to think of a better
 * solution or make a dynamic import.
 */
var _default = {
  'en-us': _enUS.default,
  'de-de': _deDE.default,
  'nl-nl': _nl_NL.default,
  'de-at': _deDE.default,
  'es-us': _esUS.default,
  'ja-jp': _jaJP.default,
  'en-gb': _enGB.default,
  'fr-fr': _frFR.default,
  'fr-ca': _frCA.default,
  'en-ca': _enCA.default,
  'pt-br': _ptBR.default,
  'es-mx': _esMX.default,
  'en-au': _enAU.default,
  'en-ie': _enIE.default,
  'it-it': _itIT.default,
  'sv-se': _svSE.default
};
exports.default = _default;